/*
 * @Author: M.D.
 * @Date: 2020-01-08 15:58:10
 * @LastEditors  : M.D.
 * @Description:
 * @Remarks:
 */
import request from './axios'

export default {
  // 用户登录  {xie,a123456}
  webLogin: data => {
    return request({
      url: '/member/member/login',
      method: 'post',
      data
    })
  },

  // 二维码登录 - 获取连接
  webLoginGetQrCode: () => {
    return request({
      url: '/member/memberWX/qrCode',
      method: 'post'
      // headers: {
      //   'Content-Type': 'application/x-www-form-urlencoded'
      // }
    })
  },

  // 轮询获取用户参数
  webGetUsrByPoll: data => {
    return request({
      url: '/member/memberWX/checkLogin',
      method: 'get',
      params: data
    })
  },

  // 扫码-绑定手机
  qCBindPhone: data => {
    return request({
      url: 'member/memberWX/bindMobile',
      method: 'get',
      params: data
    })
  },

  // 扫码-完善用户信息
  qCCompAcct: data => {
    return request({
      url: 'member/memberWX/perfectInfomation',
      method: 'post',
      data
    })
  },

  // 云平台登录注册
  cloudLogin: data => {
    return request({
      url: '/member/member/regLogin',
      method: 'post',
      data
    })
  },

  // 用户注册
  webReg: data => {
    return request({
      url: '/member/member/reg',
      method: 'post',
      data
    })
  },

  // 用户退出
  webLogout: () => {
    return request({
      url: '/member/member/quit',
      method: 'get'
    })
  },

  // 发送验证码
  getAuthCode: params => {
    return request({
      url: '/member/member/sendCode',
      params,
      method: 'get'
    })
  },

  forgetAuthCode: params => {
    return request({
      url: '/member/member/byUpdatesendCode',
      params,
      method: 'get'
    })
  },

  // 获取最近订单
  getMyOrders: params => {
    return request({
      url: '/order/goodsOrder/getPageData',
      params,
      method: 'get'
    })
  },
  // 获取最近购买的产品 lyj
  getMyProducts: params => {
    return request({
      url: '/order/goodsOrder/getMyProducts',
      params,
      method: 'get'
    })
  },
  // 更新最近购买的产品的显示顺序 lyj
  updateMyProductsUseOrder: params => {
    return request({
      url: '/order/goodsOrder/updateMyProductsUseOrder',
      params,
      method: 'post'
    })
  },

  // 更新用户信息
  updateUserInfo: data => {
    return request({
      url: '/member/member/updata',
      data,
      method: 'post'
    })
  },
  // 手机验证码验证
  validateCode: data => {
    return request({
      url: '/member/member/validateCode',
      data,
      method: 'post'
    })
  },
  updateCloudInfo: data => {
    return request({
      url: '/member/member/updateCloudInfo',
      data,
      method: 'post'
    })
  },
  // 获取我的消息
  getMessageList: params => {
    return request({
      url: '/member/notice/getList',
      params,
      method: 'get'
    })
  },
  // 修改我的消息未读状态
  updateMsgIsRead: params => {
    return request({
      url: '/member/notice/isRead/' + params.id,
      method: 'get'
    })
  },
  // 获取我的积分
  getMyPoint: params => {
    return request({
      url: '/member/memberPointRecord/myPoint',
      params,
      method: 'get'
    })
  },
  // 获取积分商品
  getPointGoods: params => {
    return request({
      url: '/member/memberPointRecord/getPointGoods',
      params,
      method: 'get'
    })
  },
  // 修改密码
  updatePwd: data => {
    return request({
      url: '/member/member/updatePwd',
      data,
      method: 'post'
    })
  },
  // 获取推荐信息
  getRecommendInfo: params => {
    return request({
      url: '/member/member/getRecommendInfo',
      params,
      method: 'post'
    })
  },
  // 获取常见问题
  getKnowledge: params => {
    return request({
      url: '/member/knowledge/getPageData',
      params,
      method: 'get'
    })
  },

  // 获取发票下载信息
  getInvoiceDown: params => {
    return request({
      url: '/member/member/getInvoiceDown',
      params,
      method: 'get'
    })
  },

  // 收货地址
  getAddress: memberId => {
    return request({
      url: '/member/memberAddress/getAddress',
      method: 'get',
      params: {
        memberId
      }
    })
  },

  // 新增收货地址
  addAddress: data => {
    return request({
      url: '/member/memberAddress/updateById',
      method: 'POST',
      data
    })
  },

  // 会员信息查询
  getMemberInfo: params => {
    return request({
      url: '/member/member/getInfo',
      method: 'post'
    })
  },

  getDitType: () => {
    return request({
      url: `/member/member/getDitType/24`,
      method: 'get'
    })
  },
  getMsgCount: () => {
    return request({
      url: `/member/notice/getCount`,
      method: 'get'
    })
  },
  getMembersByMobile: (params) => {
    return request({
      url: `/member/member/geMembersByMobile`,
      method: 'get',
      params
    })
  },

  loginSelectedAccount: (params) => {
    return request({
      url: `/member/memberWX/codeLoginSelectAccount`,
      method: 'post',
      params
    })
  }
}
